export default __webpack_public_path__ + "assets/images/back.22252270f46dc82d5713d230272e99b4.png";